import { get } from '@util/storage/get';
import { set } from '@util/storage/set';
import { remove } from '@util/storage/remove';
import { clear } from '@util/storage/clear';

const storage = { set, get, remove, clear };

export { storage };
